import { Component, forwardRef, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import moment from 'moment';
import _ from 'lodash';

@Component({
  selector: 'app-form-input-date-range',
  standalone: false,
  templateUrl: './form-input-date-range.component.html',
  styleUrl: './form-input-date-range.component.scss',
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormInputDateRangeComponent),
      multi: true
    }
  ]
})
export class FormInputDateRangeComponent implements OnInit, ControlValueAccessor {
  @Input() field: string;
  @Input() formControl: FormControl;
  @Input() label: string;
  @Input() maxDate: Date | undefined;
  @Input() minDate: Date | undefined;
  @Input() noLabel: boolean;

  public firstDayOfWeek: number = 0;
  public id: string;
  public value: [Date, Date] | null;
  
  public onChange = (_: any) => {
  };
  public onTouch = () => {
  };

  constructor() {
  }

  ngOnInit(): void {
    this.id = `${this.field}-${moment().unix()}`;
    const initialValue = this.formControl?.value;
    if (initialValue && Array.isArray(initialValue)) {
      this.value = [new Date(initialValue[0]), new Date(initialValue[1])];
    }
    // set first day of the week according to user nav lang
    const navLang = navigator.language ? _.first(_.split(navigator.language, '-')) : null;
    this.firstDayOfWeek = navLang === 'es' ? 1 : 0;
  }

  // value accessor functions
  writeValue(value: [Date, Date] | null): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  // function to catch input changes and update form in parent
  public onInput($event: any): void {
    this.onTouch();
    this.onChange(this.value);
  }

  public onClear(): void {
    this.value = null;
    this.onTouch();
    this.onChange(null);
  }
}
